export default __webpack_public_path__ + "static/media/logo.83e96dc6.png";